// api/auth.js
import axios from 'axios';
import apiClient from './client'; // solo para login y logout

// login y logout pueden usar apiClient (con interceptores)

//#region AUTH ==========================================
  export const login = (credentials) => apiClient.post('/Auth/login', credentials,{headers: {'X-Device-Id': '00001'},withCredentials:true});
  export const mfaVerification = (code) => apiClient.post('/Auth/login/mfa',code,{headers:{'X-Device-Id': '00001'},withCredentials:true})
  export const logoutDevice = () => apiClient.post('/Auth/logout/device');
  export const logoutAll = () => apiClient.post('/Auth/logout/all');
  export const eula = () => 
      apiClient.get('/Auth/EULA', {
      headers: {                   // ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  });
  export const forgotPassword = (pass) => apiClient.post('/Auth/login/forgotPassword',pass,{headers: {'X-Device-Id': '00001'},withCredentials: true})
  export const passwordMfa = (pass) => apiClient.post('/Auth/login/forgotPassword/mfa',pass,{headers: {'X-Device-Id': '00001'},withCredentials: true})
  export const password = (pass) => apiClient.post('/Auth/login/forgotPassword/change',pass,{headers: {'X-Device-Id': '00001'},withCredentials: true})
//#endregion

//#region USERS ==========================================
  export const eulaFirmed = (firmed) => 
    apiClient.post('/Users/EulaFirmed',null,{
      params: {EulaFirmed : firmed} ,  // Se convierte en ?fecha=valor en la URL
      headers: {                   // ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  })
  export const changePassword = (obj) => 
    apiClient.post('/Users/ChangePassword',obj,{
      headers: {// ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  })
  export const changeEmail = (obj) => 
    apiClient.post('/Users/ChangeEmail',obj,{
      headers: {                   // ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  })
  export const mfaChangeEmail = (obj) => 
    apiClient.post('/Users/ChangeEmail/mfa',obj,{
      headers: {                   // ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  })
//#endregion

//#region DASHBOARD ==========================================
  export const organismos = (fecha) => 
    apiClient.get('/Dashboard/organismos', {
      params: {fecha : fecha} ,  // Se convierte en ?fecha=valor en la URL
      headers: {                   // ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  }); 
  export const ventasPorDia = (fecha) => 
    apiClient.get('/Dashboard/ventasPorDia', {
      params: {fecha: fecha} , 
      headers: {  
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  });
  export const ventasPorHora = (fecha) => 
    apiClient.get('/Dashboard/ventasPorHora', {
      params: {fecha: fecha} , 
      headers: {  
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  });
  export const equipos = (fecha) => 
    apiClient.get('/Dashboard/equipos', {
      params: { fecha: fecha },  // Se convierte en ?fecha=valor en la URL
      headers: {  // ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  });

  export const empleados = (fecha) => 
    apiClient.get('/Dashboard/empleados', {
      params: { fecha: fecha },  // Se convierte en ?fecha=valor en la URL
      headers: {  // ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  });

  export const topproductos = (fecha) => 
    apiClient.get('/Dashboard/topproductos', {
      params: { fecha: fecha },  // Se convierte en ?fecha=valor en la URL
      headers: {  // ← Headers personalizados
        'X-Device-Id': '00001',
      },
      withCredentials: true 
  });

  export const inventario = (fecha) => 
    apiClient.get('/Dashboard/inventario', {
      params: {fecha : fecha},
      headers:{
        'X-Device-Id':'00001',
      },
      withCredentials: true
    })
//#endregion

// refreshToken NO debe usar apiClient para evitar el ciclo 
export const refreshTokenR = (refreshtokenvalue) => {
  // Usamos axios directamente, con withCredentials para enviar cookies
  return axios.post(`${process.env.REACT_APP_API_URL}/Auth/refresh`, {refreshToken: refreshtokenvalue}, {headers: {'X-Device-Id': '00001'},withCredentials: true});
};